import axios from "axios";

function createWithAuth(url, options) {
  const baseUrl = process.env.NODE_ENV !== "local" ? process.env.VUE_APP_API_URL : "";
  console.log(baseUrl);
  const instance = axios.create(
    Object.assign(
      {
        baseURL: baseUrl + url
      },
      {
        ...options,
        timeout: 0
      }
    )
  );
  return instance;
}

const works = createWithAuth(`/api/v1/works`);
const magazine = createWithAuth(`/api/v1/magazine`);
const code = createWithAuth(`/api/v1/code`);
const upload = createWithAuth(`/api/v1/file/upload`);
const contact = createWithAuth(`/api/v1/contact`);
const career = createWithAuth(`/api/v1/career`);
const fileDown = createWithAuth(`/api/v1/company`, {responseType: "blob"});

function apiFileDown() {
  return fileDown.get(`/`);
}

function apiFile(pageName, data) {
  return upload.post(`/${pageName}`, data);
}
function apiContact(data) {
  return contact.post(``, data);
}

function apiCode(upperCode) {
  return code.get(`/${upperCode}`);
}

function apiWorksList(params) {
  return works.get(`/`, {
    params: params,
    paramsSerializer(params) {
      const search = new URLSearchParams();
      Object.keys(params).forEach(key => {
        const value = params[key];
        if (Array.isArray(value)) {
          value.forEach(item => search.append(key, item));
          return;
        }
        if (value !== undefined && value !== null) {
          search.append(key, value);
        }
      });
      return search.toString();
    }
  });
}
function apiWorksDetail(id) {
  return works.get(`/${id}`);
}

function apiMagazineList(params) {
  return magazine.get(`/`, {
    params: params
  });
}
function apiMagazineDetail(id) {
  return magazine.get(`/${id}`);
}

function apiCareer(data) {
  return career.post(`/`, data);
}

function apiCareerController(data) {
  return career.get(`/`, data);
}

function apiPrizeList(params) {
  return works.get(`/prize`, {
    params: params
  });
}

export {
  apiFileDown,
  apiContact,
  apiFile,
  apiCode,
  apiWorksList,
  apiWorksDetail,
  apiMagazineList,
  apiMagazineDetail,
  apiCareer,
  apiPrizeList,
  apiCareerController
};
